import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './TenantEditPage.scss';
import UIButton from '@/components/shared/UIButton';
import UIPageTitle from '@/components/shared/UIPageTitle';
import useTenant from '@/hooks/useTenant';

const TenantEditPage = () => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const navigate = useNavigate();

  const { data: tenantData, isLoading, error } = useTenant(tenantId);

  const headerActions = (
    <div className="TenantEditPage__header-actions">
      <UIButton
        outline={true}
        variant="primary"
        size="medium"
        onClick={() => navigate(`/dashboard/tenants/${tenantId}`)}
      >
        Back to Details
      </UIButton>
    </div>
  );

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error || !tenantData) {
    return <div>Error loading tenant data.</div>;
  }

  const { tenant } = tenantData;

  return (
    <>
      <UIPageTitle
        title={`Edit Tenant: ${tenant.firstname} ${tenant.lastname}`}
        action={headerActions}
      />

      <div className="TenantEditPage">
        <p>Edit tenant page for ID: {tenantId}</p>
        {/* Тут буде форма редагування */}
      </div>
    </>
  );
};

export default TenantEditPage;
